export const String = {
  orders: 'orders',
  TSh: 'TSh',
  days: 'days',
  unit: 'Units',
  products: 'Products',
  pleaseWait: 'Please wait...',
  DeleteCommonText: 'Are you sure you want to remove ',
  countryCode: '+255',
  warehouse: 'warehouse',
  ordersDelivered: 'orders delivered',
  singleOrderDelivered: 'order delivered',
  order: 'order',
  singleUnit: 'Unit',
  EnterName: 'Enter name...',
  EnterPhone: 'Enter phone number...',
  EnterEmail: 'Enter email...',
  EnterVehicle: 'Enter vehicle number....',
  NoDataFound: 'No Data Found.',
}
export const Error = {
  NET_ERR: 'Please check your internet connection and try again!',
}
export const Dashboard = {
  businessDetailsReview: 'Business details in review!',
  stayTuned: 'Stay tuned! We’ll verify your details soon.',
  editKyc: 'Edit KYC details',
  welcome: 'Welcome back',
  completeBusiness: 'Complete business verification!',
  addKyc:
    'Please add your KYC details to complete your business verification and start selling on uProcure.',
  completeKyc: 'Complete KYC',
  moreInformation: 'We require more information from you!',
  uploadClear: 'Please upload clear picture of TIN Certificate and Business License.',
  congrats: 'Congratulations! Your business details are verified! 😀',
  startSelling: 'You can now start selling!',
  detailsRejected: 'Business details rejected',
  incorrectDocuments: 'Reason: ',
  contactus: 'Contact us',
}
export const contactUs = {
  title: 'Contact Us',
  message:
    'Please send us your feedback, suggestions or queries and we will get back to you by email soon.',
  sendMessage: 'Send Message',
}
export const General = {
  pleaseWait: 'Please wait...',
}
export const Profile = {
  title: 'Basic Details',
  name: 'Supplier Name: ',
  businessName: 'Contact Person:',
  phoneNumber: 'Phone number:',
  email: 'Email:',
  businessAddress: 'Business address:',
  aboutBusiness: 'About the business:',
  businessCategory: 'Supplier Category:',
  businessType: 'Business type:',
  supplierType: 'Supplier type:',
  businessDetails: 'Business details',
  bankDetails: 'Bank details',
  businessCertificate: 'Business certificates',
  tinCertificate: 'TIN Certificate',
  businessLicense: 'Business License',
  vatCertificate: 'VAT Certificate',
  foodCertificate: 'Food Category Certif…',
  hygienicCertificate: 'Hygiene Monitored Certif…',
}

export const brandsString = {
  brands: 'Brands',
  addNewBrand: 'Add new brand',
  more: '+ Add new brand',
  startAdding: 'Start adding brands!',
  manageBrands: 'You can add brands and manage them.',
  addBrand: 'Add brand',
  editBrands: 'Edit brand',
  deleteBrands: 'Delete brand',
  brandName: ' Brand name',
  upload: 'Upload',
  brandLogo: 'brand logo',
  cancel: 'Cancel',
  saveChanges: 'Save Changes',
  saveBrand: 'Save brand',
};
